(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pilacom-devis-button"] && !Shopify.designMode) return;
  try {
    (function () {
  function initDevis(modalId) {
    var modal  = document.getElementById('pdb-' + modalId);
    var form   = document.getElementById('pdb-form-' + modalId);
    var selHid = document.getElementById('pdb-selection-' + modalId);
    var submitBtn = document.getElementById('pdb-submit-' + modalId);
    var errBox = document.getElementById('pdb-form-error-' + modalId);

    if (!modal) return;

    var currentStep = 1;

    function showStep(n) {
      currentStep = n;
      modal.querySelectorAll('[data-pdb-step]').forEach(function(s) {
        var isActive = s.dataset.pdbStep == n;
        s.hidden = !isActive;
        s.classList.toggle('pdb-step--active', isActive);
      });
      modal.querySelectorAll('[data-step-dot]').forEach(function(dot) {
        var active = dot.dataset.stepDot == n;
        dot.classList.toggle('pdb-step-dot--active', active);
      });
    }

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      showStep(1);
      var first = modal.querySelector('.pdb-modal__close');
      if (first) first.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    function buildSelection() {
      var lines = [];
      modal.querySelectorAll('[data-pdb-qty-input]').forEach(function(inp) {
        var qty = parseInt(inp.value, 10) || 0;
        if (qty > 0) {
          lines.push(inp.dataset.productTitle + ' x' + qty);
        }
      });
      return lines.join(', ') || 'Aucune sélection';
    }

    // Open
    document.querySelectorAll('[data-pdb-open="' + modalId + '"]').forEach(function(btn) {
      btn.addEventListener('click', openModal);
    });

    // Close
    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-pdb-close]')) closeModal();
    });

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (!modal.hidden && e.key === 'Escape') closeModal();
    });

    // Step nav
    modal.addEventListener('click', function(e) {
      var nextBtn = e.target.closest('[data-pdb-next]');
      if (!nextBtn) return;
      var nextStep = parseInt(nextBtn.dataset.pdbNext, 10);
      if (nextStep === 3 && selHid) {
        selHid.value = buildSelection();
      }
      showStep(nextStep);
    });

    // Quantity controls
    modal.addEventListener('click', function(e) {
      var dec = e.target.closest('[data-pdb-qty-dec]');
      var inc = e.target.closest('[data-pdb-qty-inc]');
      if (!dec && !inc) return;
      var wrap = (dec || inc).closest('[data-pdb-qty-wrap]');
      var input = wrap && wrap.querySelector('[data-pdb-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 0;
      var min = parseInt(input.min, 10) || 0;
      var max = parseInt(input.max, 10) || 99;
      if (dec) input.value = Math.max(min, v - 1);
      if (inc) input.value = Math.min(max, v + 1);
    });

    // Form submit
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        // Simple validation
        var required = form.querySelectorAll('[required]');
        var missing = [];
        required.forEach(function(f) {
          if (!f.value.trim()) missing.push(f.previousElementSibling ? f.previousElementSibling.textContent.replace('*','').trim() : f.name);
        });
        if (missing.length) {
          errBox.textContent = 'Veuillez remplir les champs obligatoires : ' + missing.join(', ');
          errBox.hidden = false;
          errBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return;
        }
        errBox.hidden = true;

        // Build body field from selection + body
        var bodyField = form.querySelector('[name="contact[body]"]');
        var selectionText = selHid ? selHid.value : '';
        if (selectionText && bodyField) {
          bodyField.value = 'Produits souhaités : ' + selectionText + '\n\n' + bodyField.value;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Envoi en cours…';

        var data = new FormData(form);
        fetch('/contact#contact_form', {
          method: 'POST',
          body: data,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function(res) {
          if (res.ok) {
            showStep(4);
          } else {
            throw new Error(res.status);
          }
        })
        .catch(function() {
          errBox.textContent = "Une erreur est survenue. Veuillez réessayer ou nous contacter directement.";
          errBox.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Envoyer ma demande';
        });
      });
    }
  }

  // Init on DOMContentLoaded or immediately if already loaded
  function init() {
    document.querySelectorAll('[data-pdb-step]').forEach(function(step) {
      var mid = step.dataset.modalId;
      if (mid && !document.getElementById('pdb-' + mid).__pdbInit) {
        document.getElementById('pdb-' + mid).__pdbInit = true;
        initDevis(mid);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
